import styled from '@emotion/styled';
import { CellRole, ColumnHeaderRole } from '../../../../../../ui';

export const ColumnHeader = styled(ColumnHeaderRole)`
	flex: 1;
	padding-right: 10px;
`;

export const Column = styled(CellRole)`
	flex: 1;
	padding-right: 10px;
`;
